const convertNumberToPersianUnits = (number: number | string) => {
  if (typeof number === 'string') number = Number(number);
  if (isNaN(number) || number < 0) return '';

  const parts: string[] = [];

  const billions = Math.floor(number / 1_000_000_000);
  number %= 1_000_000_000;

  const millions = Math.floor(number / 1_000_000);
  number %= 1_000_000;

  const thousands = Math.floor(number / 1_000);

  if (billions) parts.push(`${billions} میلیارد`);
  if (millions) parts.push(`${millions} میلیون`);
  if (thousands) parts.push(`${thousands} هزار`);

  return parts.length ? parts.join(' و ') : `${number}`;
};

export default convertNumberToPersianUnits;
